import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import Button from '../../Forms/Button';
import ListCard from '../../Cards/ListCard';
import Text from '../../Text';
import { breakpoint } from '../../../constants/styles';

const Container = styled.div`
  overflow: scroll;
  max-height: 390px;
  width: 100%;
  margin-top: 32px;
  padding-bottom: 16px;
  margin-bottom: -16px;
`;

const Title = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const ErrorDescription = styled(Text)`
  margin-top: 4px;
  ${breakpoint('medium')`
    margin-top: 0px;
  `}
`;

const UploadButton = styled(Button)`
  margin-top: 12px;
  margin-bottom: 0;
  width: 152px !important;
  span {
    color: white;
    font-size: 16px;
  }
  ${breakpoint('medium')`
    width: 224px !important;
  `}
  ${breakpoint('large')`
    span {
      font-size: 12px;
    }  
  `}
`;

const FileList = ({
  fileList,
  errFileList,
  onDragOver,
  delay,
  idSubir,
  onSubirClick,
  handleDelete,
  uploadButtonText,
  tagUpload,
}) => (
  <Container id="file-list-container">
    {errFileList.map((file, i) => (
      <ListCard
        key={`file-err-${i}`}
        onDragOver={onDragOver}
        small
        id={`file-error-container-row-${i}`}
        action={(e) => handleDelete(e, { file })}
        actionId={`file-button-row-error-${i}`}
        icon="ic-filled-circle-close-18-red.svg"
      >
        <Title type="Body-2-w500" color="rbrand500" id={`file-p-row-${i}`}>
          {file.name}
        </Title>
        <ErrorDescription
          type="Caption-w400"
          color="rbrand500"
          id="dropzone-filelist-errorDescription"
        >
          {file.err}
        </ErrorDescription>
      </ListCard>
    ))}

    {fileList.map((file, i) => (
      <ListCard
        key={`file-${i}`}
        onDragOver={onDragOver}
        small
        id={`row-file-container-${i}`}
        action={(e) => handleDelete(e, { file })}
        actionId={`file-button-row-${i}`}
        icon="ic-filled-circle-close-18.svg"
      >
        {file.name}
      </ListCard>
    ))}

    {!delay && idSubir && fileList.length !== 0 ? (
      <Grid container justify="center">
        <UploadButton
          onClick={onSubirClick}
          id={`dropzone-button-${idSubir}`}
          tag={tagUpload}
          largeSize="small"
          mediumSize="large"
        >
          {uploadButtonText}
        </UploadButton>
      </Grid>
    ) : (
      ''
    )}
  </Container>
);

export default FileList;
